export type CompletenessBucket = {
  key: "location" | "finances" | "household" | "employer";
  label: string;
  filled: boolean;
  unlockCopy: string;
  step: "location" | "finances" | "household";
};

export type CompletenessInput = {
  zip_code?: string | null;
  desired_location?: string | null;
  credit_score_range?: string | null;
  income_range?: string | null;
  down_payment_savings?: string | null;
  monthly_housing_cost_bucket?: string | null;
  household_size_bucket?: string | null;
  employer_category?: string | null;
  employer_name?: string | null;
};

const has = (v?: string | null) => typeof v === "string" && v.trim().length > 0;

export function computeProfileCompleteness(attrs: CompletenessInput | null | undefined) {
  const a = attrs ?? {};
  const buckets: CompletenessBucket[] = [
    {
      key: "location",
      label: "ZIP",
      // Target city/metro is optional on the form; a ZIP (usually from the
      // Stack run) is enough to count this as done.
      filled: has(a.zip_code),
      unlockCopy: "Sharper grant + lender matches in your ZIP",
      step: "location",
    },
    {
      key: "finances",
      label: "Credit + income range",
      filled: has(a.credit_score_range) && has(a.income_range),
      unlockCopy: "Personalized readiness score and rate estimates",
      step: "finances",
    },
    {
      key: "household",
      label: "Household size",
      filled: has(a.household_size_bucket),
      unlockCopy: "Household-scoped grant eligibility",
      step: "household",
    },
    {
      key: "employer",
      label: "Employer",
      filled: has(a.employer_name) || has(a.employer_category),
      unlockCopy: "Unlock the 4th layer of your Stack (employer benefits)",
      step: "household",
    },
  ];
  const filledCount = buckets.filter((b) => b.filled).length;
  const score = Math.round((filledCount / buckets.length) * 100);
  return { score, buckets, filledCount, total: buckets.length };
}